const decodeTokenPayload = (token) => {
  if (!token) return null;

  const [, payload] = token.split(".");
  if (!payload) return null;

  try {
    const normalizedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
    const paddingLength = (4 - (normalizedPayload.length % 4)) % 4;
    const paddedPayload = `${normalizedPayload}${"=".repeat(paddingLength)}`;
    return JSON.parse(atob(paddedPayload));
  } catch {
    return null;
  }
};

export const getTokenExpiry = (token) => {
  const payload = decodeTokenPayload(token);

  return Number.isFinite(payload?.exp) ? payload.exp * 1000 : null;
};

export const isTokenExpired = (token) => {
  const expiry = getTokenExpiry(token);

  return !expiry || Date.now() >= expiry;
};
